import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { TypeCPVClass } from '../models/TypeCPVClass';
@Component({
  selector: 'app-typeCPV-class',
  templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCPVClass'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	  
	@Input() objetComplementaire : TypeCPVClass;

  constructor() { }

  public ngOnInit() {
  }
  
  
  addclassSupplementaire(){
		this.objetComplementaire.classSupplementaire.push('ClassSupplementaire');
	}
  
  removeclassSupplementaire(i){
    ArrayPopTools.pop(this.objetComplementaire.classSupplementaire, i, this.parentForm, this.getUid());
	}
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

